import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useReadChannelPlayerBaseInfo } from './use-read-channel-player-base-info';

export const useCurrentChannelStream = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);

    return useCurrentStream(baseInfo?.onlineStreams?.streams);
};
